import { useState, useEffect } from 'react'
import chevronLeft from '../../assets/chevron-left.svg'
import chevronRight from '../../assets/chevron-right.svg'
import cicleBlack from '../../assets/circle-icon.svg'
import { useSlideOverDialogContext } from './SlideOverDialogContext'
import { useSelector, useDispatch } from 'react-redux'
import {
  deselectMenuItemById,
  setSelectedItemIds,
} from '../SideNavigation/SideNavigationSlice'
import VerticalProfile from '../../Components/VerticalProfile/VerticalProfile'
import useTWSMapContext from '../../hooks/UseTWSContext'
import { MenuLabels } from '../../constants/MenuLabels'
import useErrorStatus from '../../hooks/UseErrorStatus'
import filterIcon from '../../assets/icons/filter.svg'

type SlideOverDialogProps = {
  selectedSideNav: string
}

const SlideOverDialog = (props: SlideOverDialogProps) => {
  const [isVisible, setIsVisible] = useState(true)
  const {
    surfaceSensors,
    visibleSurfaceSensors, setSurfaceSensorsVisibility,

    elevatedSensor,
    visibleElevatedSensors, setElevatedSensorsVisibility,

    activeMonitor,
    activeMonitorVisibility, setActiveMonitorVisibility,

    loadingStateForDialog
  } = useSlideOverDialogContext()
  const errorStatus = useErrorStatus()

  const toggleVisibility = (productname: any, currState: any, stateSetter : React.Dispatch<any>) => {
    if(currState.includes(productname)){
        let newState = currState.filter((item: any) => item != productname)
        stateSetter(newState)
    } 
    else{
      let newState = [...currState, productname]
      stateSetter(newState)
    }
    return
  }
  const handleButtonClick = () => {
    setIsVisible(!isVisible)
  }
  const selectedItems = useSelector(
    (state: RootState) => state.sideNav.selectedItems
  )
  return (
    <div className="h-full flex items-center z-[998] absolute left-1 top-0 justify-start">
          <div className={`flex flex-col gap-2 bg-gray-900  rounded-lg border border-gray-800 
            ${ isVisible ? 'opacity-100 p-2 visible w-64' : 'opacity-0 invisible w-0' }`}>
              <div className='flex justify-between items-center'>
                <p className='text-base inline-block uppercase font-bold px-2 text-white'>Sensor Types</p>
                <button className="flex text-white p-1 rounded-lg hover:bg-gray-700"  onClick={handleButtonClick}>
                  {' '} &#x2715;{' '}
                </button>
              </div>
              {
                loadingStateForDialog && (
                   <div className="flex flex-row flex-1 justify-center items-center h-32">
                    <svg aria-hidden="true" className="inline w-12 h-12 text-twsBlue animate-spin fill-gray-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                      <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                    </svg> 
                  </div>
                )
              }
              {
                !loadingStateForDialog && (
                  <>
                    {
                      activeMonitor &&
                      (
                        <div className='flex gap-2 rounded-lg shadow-sm bg-twsBlue/20 p-2'>
                          <div className='flex gap-2'>
                            <input type="checkbox" checked={activeMonitorVisibility}
                              onChange={(event) => { setActiveMonitorVisibility(!activeMonitorVisibility) }}
                            />
                            <p className="text-sm font-semibold text-[#FF5F15]/90 uppercase">Active Sensor Monitors</p>
                          </div>
                        </div>
                      )
                    }

                    {
                      selectedItems.includes(MenuLabels.SURFACEOBS) && surfaceSensors?.length > 0 &&
                      (
                        <div className='flex flex-col rounded-lg shadow-sm bg-twsBlue/20 p-2'>
                          <p className='text-sm font-semibold uppercase text-twsBlue'>Surface Sensors</p>
                          {
                            surfaceSensors.map((item, index) => (
                               <div className='flex gap-2' key={item + index}>
                                <input type="checkbox" checked={visibleSurfaceSensors.includes(item)}
                                  onChange={(event) => { toggleVisibility(item, visibleSurfaceSensors, setSurfaceSensorsVisibility) }}
                                />
                                <p className="text-sm font-semibold text-white/90">{item}</p>
                               </div>
                            ))
                          }
                        </div>
                      )
                     
                    }

                    {
                      selectedItems.includes(MenuLabels.ELEVATED_OBS) && elevatedSensor?.length > 0 &&
                      (
                        <div className='flex flex-col rounded-lg shadow-sm bg-twsBlue/20 p-2'>
                          <p className='text-sm font-semibold uppercase text-twsBlue'>Elevated Sensors</p>
                          {
                            elevatedSensor.map((item, index) => (
                               <div className='flex gap-2' key={item + index}>
                                <input type="checkbox" checked={visibleElevatedSensors.includes(item)}
                                  onChange={(event) => { toggleVisibility(item, visibleElevatedSensors, setElevatedSensorsVisibility) }}
                                />
                                <p className="text-sm font-semibold text-white">{item}</p>
                               </div>
                            ))
                          }
                        </div>
                      )
                    }
                  </>
                )
              }
          </div>
          {
            !isVisible && 
             <button
              className="bg-navigationBg hover:bg-gray-600 text-white animate-bounce font-bold p-2 md:p-3 lg:p-4 rounded-full"
              onClick={handleButtonClick}
            >
                <img className="h-5 w-5" src={filterIcon} alt="" />
            </button>
          }
    </div>
  )
}

export default SlideOverDialog
